import { Fetch } from 'barnyard/utils';
import _ from 'lodash';
import * as constants from '../constants';


export const suppliersFetch = () => dispatch => Fetch({
  url: '/api/sync/suppliers/',
  success: (json) => {
    dispatch({
      type: constants.SUPPLIERS_FETCH_SUCCESS,
      entities: _.keyBy(json, 'id')
    });
  }
});
